import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { List } from 'react-feather';

const DetailsTab: React.FC = () => {
  const location = useLocation()

  const [lastActiveTabUrl, setLastActiveTabUrl] = useState<string | null>(null)
  const currentUrlIsDetails = location.pathname.startsWith('/pin') || location.pathname.startsWith('/tms')
  useEffect(() => {
    if (currentUrlIsDetails) {
      setLastActiveTabUrl(location.pathname)
    }
  }, [location.pathname, currentUrlIsDetails])
  const isActive = lastActiveTabUrl !== null
  const classes = `tab ${currentUrlIsDetails ? 'active' : ''} ${isActive ? '' : 'disabled'}`;

  if (!isActive) {
    return (
      <li className={classes}>
        <List aria-hidden="true" focusable="false" />
      </li>
    )
  }

  return (
    <li className={classes}>
      <Link to={currentUrlIsDetails ? '/map' : lastActiveTabUrl} aria-label="Details Tab">
        <List aria-hidden="true" focusable="false" />
      </Link>
    </li>
  );
};

export default DetailsTab;